module.exports = __webpack_public_path__ + "static/media/ShowroomAcceIco.ceb79607.svg";